export default __webpack_public_path__ + "static/media/cms-simple.f2cea2ae.png";